<div class="sheet">
  <div class="line">
    <h4  class="upper">{{ 'MENU.FILTERS' | translate }}</h4>
    <img class="icon-xl" (click)="close()" [src]="'close.svg' | themeSource" alt="close" />
  </div>


  @if (loading() && !filters().length) {
    <div class="loading">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else {
    <div class="filters">
      @for (filter of filters(); track filter.id) {
        <label class="filter-option">
          <input class="choice" type="checkbox" [checked]="filter.isActive" (change)="toggleFilter(filter, $any($event.target).checked)">
          <span>{{ filter.name }}</span>
        </label>
      }
    </div>

    @if (filters().length) {
      <button class="btn" (click)="confirm()">
        {{ 'ACTIONS.CONFIRM' | translate }}
      </button>
      <button class="btn cancel" (click)="clearSelections()">
        {{ 'ACTIONS.CLEAR_ALL' | translate }}
      </button>
    }
  }
</div>

